import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChatService {

  private _chats = new BehaviorSubject<any[]>([]);
  private _isLoading = new BehaviorSubject<boolean>(false);
  public readonly chats$ = this._chats.asObservable();
  public readonly isLoading$ = this._isLoading.asObservable();


  private _usuarioSelecionado = new BehaviorSubject<any>(null);
  public usuarioSelecionado = this._usuarioSelecionado.asObservable();

  setLoading(isLoading: boolean) {
    this._isLoading.next(isLoading);
  }

  // addChat(message: any) {
  //   this._chats.next([...this._chats.value, message]);
  // }

  addChat(message: any) {
    const chats = this._chats.value;
  
    // Verifica se já existe um chat com o mesmo uniqueString
    const exists = chats.some(chat => chat.uniqueString === message.uniqueString);
  
    if (!exists) {
      this._chats.next([...chats, message]);
    } else {
      console.warn(`Mensagem com uniqueString ${message.uniqueString} já existe e não foi adicionada.`);
    }
  }

  addChats(newChats: any[]) {
    this._chats.next([...this._chats.value, ...newChats]);
  }

  clearChats() {
    this._chats.next([]);
  }

  changeUsuarioSelecionado(newData: any) {
    this._chats.next([]);
    this._usuarioSelecionado.next(newData);

    console.log('changeUsuarioSelecionado', this.usuarioSelecionado);
  }
}
